import flatPicker from "vue-flatpickr-component";
import flatpickr from "flatpickr";
import Vue from "vue"
import "flatpickr/dist/flatpickr.css";
const Portuguese = require("flatpickr/dist/l10n/pt.js").default.pt;
flatpickr.localize(Portuguese);
Vue.use(flatPicker);
